import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <FeaturesSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
        <CardsSection />
        <AppSection />
        <RankingSection />
        <FaqSection />
        <UpdatesSection />
        <MediaSection />
        <ContactSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}